import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { FC, useMemo } from 'react'
import { useStyle } from './styling'
import { useGetDiscountCodeOnMount } from '@user/store/discountCode/hooks/useGetDiscountCodeOnMount'
import { ReferralDiscountDetailsDrawer } from '../Details/ReferralDiscountDetailsDrawer/ReferralDiscountDetailsDrawer'
import { useDialogState } from '@user/utils/useDialogState'
import Grid from '@mui/material/Grid'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

interface Props {
  discountCodeId: string
}

export const DiscountCodeCardSmall: FC<Props> = (props: Props) => {
  const { discountCodeId } = props

  const { discountCode, loadingStatus } =
    useGetDiscountCodeOnMount(discountCodeId)

  const typesCsv = useMemo(
    () =>
      discountCode?.discountLineItems
        .map((x) => `${x.referralType === 0 ? 'New' : 'Existing'} Customer`)
        .filter((value, index, self) => self.indexOf(value) === index)
        .sort()
        .join(', '),
    [discountCode?.discountLineItems],
  )

  const [open, onOpen, onClose] = useDialogState()

  const theme = useTheme()

  return (
    <>
      <Grid container direction="column" maxWidth={'400px'}>
        {loadingStatus === 'pending' ? (
          <CircularProgress />
        ) : discountCode ? (
          <>
            <Grid item>
              <Typography component="span" variant="subtitle2">
                Referral Discount (Optional):&nbsp;
              </Typography>

              <Typography component="span" variant="body2">
                {discountCode.code} - {discountCode.name}
              </Typography>
            </Grid>
            <Grid item>
              <Typography component="span" noWrap variant="subtitle2">
                Type(s):&nbsp;
              </Typography>

              <Typography component="span" noWrap variant="body2">
                {typesCsv}
              </Typography>
            </Grid>
            <Grid item>
              <Typography component="span" noWrap variant="subtitle2">
                Details:&nbsp;
              </Typography>

              <Typography component="span" variant="body2">
                {discountCode.description}
              </Typography>
            </Grid>

            <Grid
              container
              style={{
                paddingTop: theme.spacing(1.25),
                paddingRight: theme.spacing(3.75),
              }}
            >
              <Grid item>
                <Box
                  sx={useStyle.viewFullDetailsLink}
                  component="div"
                  onClick={onOpen}
                  data-test-id="view-full-details-link"
                >
                  View Full Details
                </Box>
              </Grid>
            </Grid>
          </>
        ) : (
          <Grid
            container
            style={{
              paddingLeft: theme.spacing(1),
              paddingTop: theme.spacing(0.4),
            }}
          >
            <Grid item>
              <Box sx={useStyle.label}>No Discount Code</Box>
            </Grid>
          </Grid>
        )}
      </Grid>
      {discountCode && (
        <ReferralDiscountDetailsDrawer
          onClose={onClose}
          open={open}
          referralDiscountCode={discountCode}
        />
      )}
    </>
  )
}
DiscountCodeCardSmall.displayName = 'DiscountCodeCardSmall'
